import z from "zod";

const translationPath =
  "page.4uBus.integrationRule.integrationRuleRelationshipGroup.errors.";

const uBusRelationshipGroupSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error: translationPath + "u_bus_relationship_group",
  },
);

export const integrationRuleRelationshipGroupSchema = z.object({
  id: z.string().optional(),
  priority: z.string().nullish(),
  uBusRelationshipGroup: uBusRelationshipGroupSchema,
});

export type TIntegrationRuleRelationshipGroupForm = z.infer<
  typeof integrationRuleRelationshipGroupSchema
>;
